import React, { useEffect, useState } from 'react';
import { FormElement, FormLabel, FormInput, FormNumberInput, DragHandle, FormToggle } from "../components/StyledElements";
import { Handle, Position, useUpdateNodeInternals } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { Icon } from "@iconify/react";
import { CloseButton } from '../components/CloseButton';


export const RouterNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Router" description="Transform data using an AI language model" onAdd={() => onAdd(500)} style={style} />
  )
};

export const RouterNode = ({ id, data }) => {
  console.log("!!! Router NODE DATA: ", data);
  const updateNodeInternals = useUpdateNodeInternals();
  const [showOptions, setShowOptions] = useState(false);
  const [localData, setLocalData] = useState({
    routeCount: 1,
    routes: [{
      id: "route-1",
      label: "route 1",
      choice_criteria: "",
    }],
    model: "Agentwire-GPT-4o",
    useChatHistory: false,
    useAgentMemory: false,
    useUserMemory: false,
    useSecondaryEndpoint: false,
  });

  console.log("!!! Router NODE LOCAL DATA: ", localData);

  useEffect(() => {
    console.log("!!!MODEL: ", data.model);
    if (!data) {
      return;
    }
    setLocalData({
      routeCount: data.routeCount || 1,
      routes: data.routes || [{
        id: "route-1",
        label: "route 1",
        choice_criteria: "",
      }],
      useChatHistory: data.useChatHistory || false,
      useAgentMemory: data.useAgentMemory || false,
      useUserMemory: data.useUserMemory || false,
      useSecondaryEndpoint: data.useSecondaryEndpoint || false,
      model: data.model || "Agentwire-GPT-4o",
    });
  }, [data]);

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Router" />
        <FormElement>
          <FormLabel label="Route Count" />
          <FormNumberInput
            value={localData?.routeCount || 1}
            onChange={(e) => {
              const newRoutes = [...localData.routes].slice(0, e.target.value);
              while (newRoutes.length < e.target.value) {
                newRoutes.push({
                  id: `route-${crypto.randomUUID()}`,
                  label: "route " + (newRoutes.length + 1),
                  choice_criteria: "",
                });
                console.log("!!! ROUTE COUNT CHANGE: ", e.target.value, newRoutes);
                setLocalData({ ...localData, routeCount: e.target.value, routes: newRoutes });
                data.onUpdateData(id, { routeCount: e.target.value, routes: newRoutes });
                updateNodeInternals(id);
              }
            }}
            min={1}
            step={1}
          />
        </FormElement>
        {
          Array.from({ length: localData.routeCount }).map((_, index) => (
            <FormElement key={index}>
              <FormInput
                placeholder={`Enter label for route ${index + 1}`}
                value={localData.routes[index]?.label ?? "route"}
                onChange={(e) => {
                  const newLabel = e.target.value;
                  const oldRoute = localData.routes[index];
                  const newRoutes = [...localData.routes];
                  newRoutes[index] = { ...oldRoute, label: newLabel };
                  setLocalData({ ...localData, routes: newRoutes });
                  data.onUpdateData(id, { routes: newRoutes });
                  data.onRenameInput?.(id, oldRoute.id, newLabel);
                  console.log("!!! ROUTE LABEL CHANGE: ", newRoutes);
                  updateNodeInternals(id);
                }}
              />
              <FormLabel label="Choice Criteria" style={{ marginTop: "4px" }} />
              <FormInput
                as="textarea"
                rows={3}
                placeholder={`Enter choice criteria for route ${index + 1} (e.g., input contains "sales")`}
                value={localData.routes[index]?.choice_criteria ?? ""}
                onChange={(e) => {
                  const newCriteria = e.target.value;
                  const oldRoute = localData.routes[index];
                  const newRoutes = [...localData.routes];
                  newRoutes[index] = { ...oldRoute, choice_criteria: newCriteria };
                  setLocalData({ ...localData, routes: newRoutes });
                  data.onUpdateData(id, { routes: newRoutes });
                  console.log("!!! ROUTE CRITERIA CHANGE: ", newRoutes);
                  updateNodeInternals(id);
                }}
              />
            </FormElement>
          ))
        }

        <div style={{ display: "flex", flexDirection: "row", gap: "4px", alignItems: "center", zIndex: 100000, marginBottom: "4px" }}>
          <FormLabel label="Options" style={{ margin: 0 }} />
          <div style={{ marginLeft: "10px", justifyContent: "center", cursor: "pointer" }} onClick={() => setShowOptions(!showOptions)}>
            <Icon icon={showOptions ? "mdi:chevron-up" : "mdi:chevron-down"} style={{ fontSize: "32px", color: "var(--main-font-color)" }} />
          </div>
        </div>
        <div style={{ display: showOptions ? "flex" : "none", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "row", gap: "4px", justifyContent: "space-between" }}>
            <FormElement style={{ width: "50%" }}>
              <FormLabel label="Use Agent Memory" />
              <FormToggle
                checked={localData?.useAgentMemory ?? false}
                onChange={(e) => {
                  setLocalData({ ...localData, useAgentMemory: e.target.checked });
                  data.onUpdateData(id, { useAgentMemory: e.target.checked });
                }}
              />
            </FormElement>
            <FormElement style={{ width: "50%" }}>
              <FormLabel label="Use User Memory" />
              <FormToggle
                checked={localData?.useUserMemory ?? false}
                onChange={(e) => {
                  setLocalData({ ...localData, useUserMemory: e.target.checked });
                  data.onUpdateData(id, { useUserMemory: e.target.checked });
                }}
              />
            </FormElement>
          </div>
          <div style={{ display: "flex", flexDirection: "row", gap: "4px", justifyContent: "space-between" }}>
            <FormElement style={{ width: "50%" }}>
              <FormLabel label="Use Chat History" />
              <FormToggle
                checked={localData?.useChatHistory ?? false}
                onChange={(e) => {
                  setLocalData({ ...localData, useChatHistory: e.target.checked });
                  data.onUpdateData(id, { useChatHistory: e.target.checked });
                }}
              />
            </FormElement>
            <FormElement style={{ width: "50%" }}>
              <FormLabel label="Use Secondary Endpoint" />
              <FormToggle
                checked={localData?.useSecondaryEndpoint ?? false}
                onChange={(e) => {
                  setLocalData({ ...localData, useSecondaryEndpoint: e.target.checked });
                  data.onUpdateData(id, { useSecondaryEndpoint: e.target.checked });
                }}
              />
            </FormElement>
          </div>
          <FormElement>
            <FormLabel label="Model" />
            <FormInput
              placeholder="Enter model name (e.g., gpt-3.5-turbo)"
              value={localData?.model ?? ""}
              onChange={(e) => {
                console.log("!!! METHOD CHANGE: ", e.target.value);
                setLocalData({ ...localData, model: e.target.value });
                data.onUpdateData(id, { model: e.target.value });
              }}
            />
          </FormElement>
        </div>
        <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
        {
          Array.from({ length: localData.routeCount }).map((_, index) => (
            <Handle key={index} type="source" position={Position.Right} style={{ top: `${175 + (index * 200)}px`, height: "12px", width: "12px" }} id={localData.routes[index].label} />
          ))
        }
      </div>
    </div>
  );
};

export default RouterNode;

